import { defineStore } from 'pinia'
import { useCacheData } from '@/hooks';
import { queryProvision } from '@/api';

const { localCache } = useCacheData();

export const usePopupStore = defineStore('popup', {
  state: () => {
    return {
      rewards: [],
      rewardInfo: '',
      documentType: '',
      frameUrl: '',
      frameTitle: '',
      gameFrameUrl: '',
      gameFrameCloseFn: undefined,
      livechatFrameUrl: '',
      walletAccount: null,
      walletCloseFn: undefined,
      showReward: false,
      showAgeVerifiction: false,
      showDocument: false,
      showInAppFrame: false,
      showGameFrame: false,
      showLivechatFrame: false,
      showBindWallet: false,
      showTransactionPassword: false,
      showShare: false,
      provision: {}, // 条款
      showLuckySpin: false,
    }
  },
  actions: {
    set(key, value = true) {
      this[key] = value;
    },
    initProvision() {
      return localCache({
        cacheKey: 'provision',
        defaultData: [],
        dataApi: queryProvision,
        formatData: data => {
          let obj = {};
          data.map(item => {
            obj[item.code] = item
          })
          return obj;
        },
        dataProcessing: data => {
          this.provision = data
        }
      })
    },
    showRewards(rewards, rewardInfo) {
      if(Array.isArray(rewards)) {
        this.rewards = rewards;
      } else {
        this.rewards = [{ type: "cash", amount: rewards }];
      }
      this.rewardInfo = rewardInfo;
      this.showReward = true;
    },
    openUrlInFrame(url, title = '') {
      this.frameUrl = url;
      this.frameTitle = title;
      this.showInAppFrame = true;
    },
    closeUrlInFrame() {
      this.frameUrl = '';
      this.frameTitle = '';
      this.showInAppFrame = false;
    },
    openGameFrame(url, closeCallback) {
      this.gameFrameUrl = url;
      this.gameFrameCloseFn = closeCallback || undefined;
      this.showGameFrame = true;
    },
    closeGameFrame() {
      this.gameFrameUrl = '';
      if (this.gameFrameCloseFn) {
        this.gameFrameCloseFn()
      }
      this.gameFrameCloseFn = undefined;
      this.showGameFrame = false;
    },
    openLivechatFrame(url) {
      this.livechatFrameUrl = url;
      this.showLivechatFrame = true;
    },
    closeLivechatFrame() {
      this.livechatFrameUrl = '';
      this.showLivechatFrame = false;
    },
    openBindWallet(account, closeCallback) {
      this.walletAccount = account || null;
      this.walletCloseFn = closeCallback || undefined;
      this.showBindWallet = true;
    },
    closeBindWallet() {
      this.walletAccount = null;
      if (this.walletCloseFn) {
        this.walletCloseFn()
      }
      this.walletCloseFn = undefined;
      this.showBindWallet = false;
    },
    openDocument(type) {
      this.showDocument = true;
      this.documentType = type;
    },
    openLuckySpin(closeCallback) {
      this.luckySpinCloseFn = closeCallback || undefined;
      this.showLuckySpin = true;
    },
    closeLuckySpin() {
      if (this.luckySpinCloseFn) {
        this.luckySpinCloseFn()
      }
      this.luckySpinCloseFn = undefined;
      this.showLuckySpin = false;
    },
  }
})
